module.exports = __webpack_public_path__ + "media/images/point/specialPosition-da4f9d7c5583f45cd4a594ba10bb5634.svg";